import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from "react";
import Tracker from "./tracker";
import { connect } from "react-redux";
import { Container, Row, Col } from "reactstrap";
import {
  getClientName,
  displayPopUp,
  getSelfCareData,
} from "./welcomeBlockSlice";
import TrackerPopUp from "./popUpActions";
import gaParams from "../../../utilities/analytics/constants";
import { gaEvent } from "../../../utilities/analytics/tracking";
import PopUp from "../../Shared/Popup/PopUp";
import { handleURL } from "../../../utilities/StringHelpers/StringHelpers";
import { isMobile } from "react-device-detect";
import { setBenefitBlockState } from "../PopupBenefitBlock/BenefitSlice";
import { CustomerType } from "./welcomeTypeEnum";
import "./welcome.scss";
import Config from "../../../Config";
import './tracker.scss';
import { createReportSelfCareArea } from "../../../utilities/reports/createReport";


const Welcome = (props) => {

  useEffect(() => {
    props.getClientName();
    gaEvent(
      gaParams.PERSONAL_AREA_SHOW_WELCOME.category,
      gaParams.PERSONAL_AREA_SHOW_WELCOME.eventType,
      props.loginData.userDetails.role,
    );
    return () => {
      props.displayPopUp(false);
    };
  }, []);

  useEffect(() => {
    if (
      props.benefitBlockContent.isReady ||
      CheckPopUpBenefitBlockIsNotExist()
    ) {
      props.getSelfCareData(props.benefitBlockContent.blockId);
      props.setBenefitBlockState(false);
    }
  }, [props.benefitBlockContent.isReady]);

  const CheckPopUpBenefitBlockIsNotExist = () => {
    let isPopUpBenefitBlockNotExist = false;
    try {
      const res = Object.values(props.context._componentLoader.cache).find(
        (item) => item.displayName == "Block/PopupBenefitBlock",
      );
      if (res === undefined) {
        isPopUpBenefitBlockNotExist = true;
      }
    } catch (e) {
      console.log(e);
    }
    return isPopUpBenefitBlockNotExist;
  };

  const CloseModal = () => {
    props.displayPopUp(false);
  };

  const navigateToPage = (url) => {
    handleURL(url, props.context);
  };

  let customerName = "";
  if (
    props.loginData.userDetails.firstName ||
    props.loginData.userDetails.lastName
  ) {
    customerName = `${props.loginData.userDetails.firstName
      ? props.loginData.userDetails.firstName
      : ""
      } ${props.loginData.userDetails.lastName
        ? props.loginData.userDetails.lastName
        : ""
      }`;
  } else {
    customerName = "מה שלומך היום?";
  }
  let classNames =
    "welcome-main" + (props.trackerLoaded ? " with-tracker" : "");
  const organizationData = props.welcomeState?.organizationState;
  const getMainImage = () => {
    let customerType = CustomerType.Unknown;
    let mode = {};
    if (!organizationData) {
      customerType = CustomerType.Private;
    } else {
      customerType = CustomerType.Business;
    }
    switch (customerType) {
      case CustomerType.Business:
        if (props.isShowTracker) {
          mode.title = "tracker";
          mode.image = isMobile
            ? organizationData?.mobileImageModeOne?.value?.url
            : organizationData?.desktopImageModeOne?.value?.url;
          mode.link = null;
        } else if (
          !props.isShowTracker &&
          organizationData?.adBannerDesktopImageModeTwo?.value?.url
        ) {
          mode.title = "banner";
          mode.image = isMobile
            ? organizationData?.adBannerMobileImageModeTwo?.value?.url
            : organizationData?.adBannerDesktopImageModeTwo?.value?.url;
          mode.link = organizationData.adBannerUrlModeTwo?.value;
        } else {
          mode.title = "default";
          mode.image = isMobile
            ? organizationData?.mobileImageModeOne?.value?.url
            : organizationData?.desktopImageModeOne?.value?.url;
          mode.link = null;
        }
        return mode;
      case CustomerType.Private:
        if (props.isShowTracker) {
          mode.title = "tracker";
          mode.image = isMobile
            ? props.contentData.mobileMainImage.expandedValue?.url
            : props.contentData.desktopMainImage.expandedValue?.url;

          mode.link = null;
        } else if (
          !props.isShowTracker &&
          props.contentData.desktopAdBannerImage.expandedValue?.url
        ) {
          mode.title = "banner";
          mode.image = isMobile
            ? props.contentData.mobileAdBannerImage.expandedValue?.url
            : props.contentData.desktopAdBannerImage.expandedValue?.url;
          mode.link = props.contentData.adBannerLink?.value;
        } else {
          mode.title = "default";
          mode.image = isMobile
            ? props.contentData.mobileMainImage.expandedValue?.url
            : props.contentData.desktopMainImage.expandedValue?.url;
          mode.link = null;
        }
        return mode;
    }
  };
  const mode = getMainImage();
  const backgroundImage = isMobile
    ? props.contentData?.itemImageMobile?.expandedValue?.url
    : props.contentData?.itemImage?.expandedValue?.url;

  //method that count number of updates in tracker for reports
  const getNumberOFUpdatesInTracker = () => {
    let numberOFUpdatesInTracker = 0;
    numberOFUpdatesInTracker =
      props.welcomeState?.trackerState?.abroadPackagesItems?.length +
      props.welcomeState?.trackerState?.customerDeliveriesItems?.length +
      props.welcomeState?.trackerState?.financeIssueItems?.length +
      props.welcomeState?.trackerState?.followUpRefundItem?.length +
      props.welcomeState?.trackerState?.managerCallItems?.length +
      props.welcomeState?.trackerState?.refundItems?.length +
      props.welcomeState?.trackerState?.technicianVisitItems?.length;
    return numberOFUpdatesInTracker;
  };

  let reportSelfCareData = props.welcomeState?.report;
  useEffect(() => {
    if (reportSelfCareData != undefined) {
      createReportEnterSelfCare();
    }
  }, []);

  //check customer type for reports
  let customerAccount = "פרטי";
  if (props.welcomeState?.customerType?.isBusiness) {
    customerAccount = "עסקי";
  }
  //customer info for reports
  const customerNameReport = customerName;
  const subscriberReport = props.loginData?.userDetails?.contactNumber;
  const idNumberReport = props.loginData?.userDetails?.IDNumber;
  const organizationCodeList = organizationData?.organizationCodeList?.value;
  const numberOfInvoices = reportSelfCareData?.invoices?.length;
  let productsFlag = "";
  if (reportSelfCareData?.products?.length == 0) {
    productsFlag = "אינדיקציה: אין מוצרים ללקוח";
  }
  let numberOFUpdatesInTracker = getNumberOFUpdatesInTracker();

  //method => send data to DWH
  const createReportEnterSelfCare = () => {
    createReportSelfCareArea(
      customerNameReport,
      subscriberReport,
      idNumberReport,
      customerAccount,
      organizationCodeList,
      numberOFUpdatesInTracker,
      numberOfInvoices,
      productsFlag,
    );
  };


  return (
    <Container
      style={{
        padding: "0",
        margin: "0",
      }}
      fluid={true}
      className={classNames}
      alt="הודעות לקוח"
    >
      <div className="tracker-wrapper-old-selfcare">
        <PopUp showPopUp={props.showPopUp} onClose={() => CloseModal()}>
          <TrackerPopUp
            popUpType={props.popUpType}
            {...props.popUpProps}
            context={props.context}
            urlToAbroad={props.contentData.pageRefToMyAbroadPackage.value}
            navigateToPage={navigateToPage}
            contentData={props.contentData}
          />
        </PopUp></div>
      {organizationData ? (
        <Row
          style={{
            width: "100%",
            overflow: "hidden",
            justifyContent: "center",
            margin: "0",
          }}
        >
          {!isMobile
            ? organizationData.orgBannerDesktop.value?.url && (
              <Image src={
                  Config.epiBaseUrl +
                  organizationData?.orgBannerDesktop?.value?.url
                } />
            )
            : organizationData.orgBannerMobile.value?.url && (
              <Image src={
                  Config.epiBaseUrl +
                  organizationData?.orgBannerMobile?.value?.url
                } />
            )}
        </Row>
      ) : null}
      {backgroundImage && (
        <Image style={{ width: "100%", position: "absolute " }}
          src={Config.epiBaseUrl + backgroundImage} />
      )}
      {props.isShowTracker ? (
        <div
          style={
            !isMobile
              ? {
                position: "relative",
                backgroundImage: `

                  url(${Config.epiBaseUrl + mode?.image})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "top center",
                overflow: "hidden",
              }
              : {
                position: "relative",
                backgroundImage: `url(${Config.epiBaseUrl + mode?.image})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "top center",
                backgroundSize: "contain",
                overflow: "hidden",
              }
          }
        >
          {mode?.image && !isMobile && (
            <div>
              <Image style={{
                  visibility: "hidden",
                  position: "relative",
                }}
                src={Config.epiBaseUrl + mode?.image} />
            </div>
          )}
          <div
            style={
              mode?.image
                ? !isMobile
                  ? { position: "relative", marginTop: "-140px" }
                  : { position: "relative", top: "20px" }
                : !isMobile
                  ? { paddingTop: "60px" }
                  : null
            }
          >
            <Row
              className="welcome-name-row"
              style={{ maxWidth: "1280px", margin: "auto" }}
            >
              <Col
                style={{ padding: "0" }}
                className={`${props.financeMessage &&
                  !isMobile &&
                  props.numOfItems > 1 &&
                  props.isShowTracker
                  ? "welcome-name-finance-issue-up-name"
                  : ""
                  } welcome-content welcome-name`}
              >
                <div
                  className="welcome-hello"
                  style={
                    mode?.title == "tracker" && mode?.image
                      ? { color: "white" }
                      : { color: "black" }
                  }
                >
                  שלום {customerName},
                </div>
              </Col>
            </Row>
            <Row style={{ width: "100%", margin: "0", marginTop: "10px" }}>
              <Col className={" welcome-content welcome-tracker p-0"}>
                <div className="tracker-wrapper-old-selfcare">
                  <Tracker
                    whiteTitle={
                      mode?.title == "tracker" && mode?.image ? true : false
                    }
                    epiData={props.contentData}
                    context={props.context}
                  /></div>
              </Col>
            </Row>
          </div>
        </div>
      ) : mode.image &&
        !props.isShowTracker &&
        !props.welcomeState.trackerState.isLoading ? (
        <>
          <Row
            className="welcome-name-row"
            style={
              mode.title == "default"
                ? {
                  width: "100%",
                  position: "absolute",
                  bottom: "0",
                  margin: "0 0 90px 0 ",
                  zIndex: "4",
                }
                : {
                  width: "100%",
                  position: "absolute",
                  margin: "0",
                  zIndex: "4",
                  paddingTop: "65px",
                }
            }
          >
            <Col
              style={{ padding: "0", maxWidth: "1280px", margin: "auto" }}
              className={`${props.financeMessage &&
                !isMobile &&
                props.numOfItems > 1 &&
                props.isShowTracker
                ? "welcome-name-finance-issue-up-name"
                : ""
                } welcome-content welcome-name`}
            >
              <div
                className="welcome-hello"
                style={
                  (mode?.title == "tracker" || mode?.title == "default") &&
                    mode?.image
                    ? { color: "white" }
                    : { color: "black" }
                }
              >
                שלום {customerName},
              </div>
            </Col>
          </Row>
          <Row
            style={{
              width: "100%",
              overflow: "hidden",
              justifyContent: "center",
              margin: "0 0 40px 0",
              cursor: mode?.link != null && "pointer",
            }}
          >
            <div>
              <Image onClick={() =>
                  mode?.link != null && props.context.navigateTo(mode?.link)
                }
                src={Config.epiBaseUrl + mode?.image}
                style={{
                  width: isMobile ? "100vw" : "unset",
                  position: "relative",
                }} />
            </div>
          </Row>
        </>
      ) : (
        <Row
          className="welcome-name-row"
          style={{ maxWidth: "1280px", margin: "auto", paddingTop: "60px" }}
        >
          <Col
            style={{ padding: "0" }}
            className={`${props.financeMessage &&
              !isMobile &&
              props.numOfItems > 1 &&
              props.isShowTracker
              ? "welcome-name-finance-issue-up-name"
              : ""
              } welcome-content welcome-name`}
          >
            <div
              className="welcome-hello"
              style={
                mode?.title == "tracker" && mode?.image
                  ? { color: "white" }
                  : { color: "black" }
              }
            >
              שלום {customerName},
            </div>
          </Col>
        </Row>
      )}
    </Container>
  );
};

const mapStateToProps = (state) => {
  let initTrackerState = state.welcomeBlock.trackerState;
  let initState = state.welcomeBlock.trackerState;

  return {
    loginData: state.authentication?.loginData,
    trackerLoaded: !initTrackerState.isLoading && !initTrackerState.error,
    popUpType: initTrackerState.popUpType,
    popUpProps: initTrackerState.popUpProps,
    showPopUp: initTrackerState.showPopUp,
    financeMessage: state.welcomeBlock.trackerState.isFinanceMessage,
    benefitBlockContent: state.popupBenefitBlock.benefitBlockContent,
    numOfItems: initTrackerState.numOfItems,
    isShowTracker: initState.isShowTracker,
    organizationId: state.welcomeBlock.organizationId,
    welcomeState: state.welcomeBlock,
    cmsContent: state.iContentRepo,
  };
};
const mapDispatchToProps = {
  getClientName,
  displayPopUp,
  getSelfCareData,
  setBenefitBlockState,
};

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);
